module.exports = __webpack_public_path__ + "images/highlight.be6feed9af976c52bfe3716e551bb111.png";